import axios from 'axios';

const redirectMCM = () => axios.get('https://provision-gateway.develop.embrix.org/mcmSelfCare');

export default redirectMCM;
